/* eslint-disable no-nested-ternary */
import React from 'react';
import { Form, InputNumber } from 'antd';
import PropTypes from 'prop-types';


function parseJsonResponse(key, json) {
  if (!json || typeof json !== 'string') return null;

  const data = JSON.parse(json);
  return data?.[key];
}


const fields = [
  {
    name: 'salary',
    label:
      'Оплата труда работников (включая расходы на оплату страховых взносов на ФОТ)',
  },
  {
    name: 'material',
    label:
      'Расходы на приобретение материалов и комплектующих, необходимых для реализации проекта',
  },
  {
    name: 'equipment',
    label:
      'Расходы, на приобретение оборудования и иного имущества, необходимых для реализации Проекта',
  },
  { name: 'other', label: 'Прочие прямые расходы' },
  {
    name: 'paper',
    label:
      'Накладные и общехозяйственные расходы, предусмотренные учетной политикой организации',
  },
];

const SmetaRow = ({
  index, coexecutorData, projectYears, formRef,
}) => {
  const row = fields[index];

  const handleUpdateTotal = () => {
    const allFields = formRef.current.getFieldsValue();
    const smeta = allFields.smeta || {};
    let total = 0;

    projectYears.forEach((year) => {
      total += smeta[`${row.name}${year}`] || 0;
    });

    const stepTotal = coexecutorData.coexecutorsPersonId.stepTotal || 0;

    smeta[`${row.name}Total`] = total;
    smeta[`${row.name}Percent`] = Math.round((total / stepTotal) * 100);


    formRef.current?.setFieldsValue({
      ...allFields,
      smeta,
    });
  };

  return (
    <div className="common-table-row">
      <div
        className="common-table-row-cell"
        style={{ width: '5%', textAlign: 'center' }}
      >
        {index + 1}
      </div>
      <div
        className="common-table-row-cell"
        style={{ width: '25%', textAlign: 'left' }}
      >
        {row.label}
      </div>
      <div className="common-table-row" style={{ width: '70%' }}>
        <div
          className="common-table-row-cell"
          style={{
            width: '30%',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Form.Item
            style={{ width: '55%' }}
            name={['smeta', `${row.name}Total`]}
            initialValue={parseJsonResponse(`${row.name}Total`, coexecutorData.smeta) || 0}
          >
            <InputNumber
              formatter={(value) => (parseInt(value, 10) || 0).toLocaleString('ru-RU')}
              disabled
            />
          </Form.Item>
          <span>руб.</span>
        </div>
        {projectYears.map((year, i) => (
          <div
            key={year}
            className="common-table-row-cell"
            style={{
              width: `${70 / projectYears.length}%`,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Form.Item
              style={{ width: '55%' }}
              name={['smeta', `${row.name}${year}`]}
              initialValue={typeof parseJsonResponse(`${row.name}${year}`, coexecutorData.smeta) === 'number' ? parseJsonResponse(`${row.name}${year}`, coexecutorData.smeta) : 0}
            >
              <InputNumber
                min={0}
                onChange={handleUpdateTotal}
                formatter={(value) => (parseInt(value, 10) || 0).toLocaleString('ru-RU')}
              />
            </Form.Item>
            <span>руб.</span>
          </div>
        ))}
        <div
          className="common-table-row-cell"
          style={{
            width: `${15}%`,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            borderRight: '1px solid #d9d9d9',
          }}
        >
          <Form.Item
            style={{ width: '55%' }}
            name={['smeta', `${row.name}Percent`]}
            initialValue={typeof parseJsonResponse(`${row.name}Percent`, coexecutorData.smeta) === 'number' ? parseJsonResponse(`${row.name}Percent`, coexecutorData.smeta) : 0}
          >
            <InputNumber
              disabled
              formatter={(value) => (parseInt(value, 10) || 0).toLocaleString('ru-RU')}
            />
          </Form.Item>
          <span>%</span>
        </div>
      </div>
    </div>
  );
};

SmetaRow.propTypes = {
  index: PropTypes.number.isRequired,
  coexecutorData: PropTypes.shape().isRequired,
  projectYears: PropTypes.shape().isRequired,
  formRef: PropTypes.shape().isRequired,
};

export default SmetaRow;
